import { StaticPageLayout } from '@/components/layout/StaticPageLayout';

export function BlogPage() {
 return (
  <StaticPageLayout title='Engineering Blog'>
   <div className='grid gap-8'>
    <div className='border border-border p-6 hover:bg-muted/10 transition-colors cursor-pointer'>
     <div className='text-xs font-mono text-primary mb-2'>
      MAY 15, 2024 • ARCHITECTURE
     </div>
     <h2 className='text-2xl font-bold mb-3'>
      Scaling Real-time Audio Processing for AI Interviews
     </h2>
     <p className='text-muted-foreground'>
      How we reduced latency to under 200ms using edge computing and optimized
      WebSocket streams.
     </p>
    </div>

    <div className='border border-border p-6 hover:bg-muted/10 transition-colors cursor-pointer'>
     <div className='text-xs font-mono text-primary mb-2'>
      APRIL 02, 2024 • AI RESEARCH
     </div>
     <h2 className='text-2xl font-bold mb-3'>
      Fine-tuning LLMs for Technical Depth
     </h2>
     <p className='text-muted-foreground'>
      Moving beyond generic coding answers to architectural reasoning and system
      design capability.
     </p>
    </div>

    <div className='border border-border p-6 hover:bg-muted/10 transition-colors cursor-pointer'>
     <div className='text-xs font-mono text-primary mb-2'>
      MARCH 20, 2024 • PRODUCT
     </div>
     <h2 className='text-2xl font-bold mb-3'>
      Introducing: System Design Mode
     </h2>
     <p className='text-muted-foreground'>
      A new whiteboard-integrated interview type for senior engineers.
     </p>
    </div>
   </div>
  </StaticPageLayout>
 );
}
